/* eslint no-unused-vars: 0 */
import $ from 'jquery';

import initCookiePopup from './cookie-popup';
import initScrollTo from './scroll-to';
import banner from './banner';
import Nav from './mobile-menu';
import dropdownMenu from './dropdown-menu';
import embedMessage from './embed-message';

$(document).ready(() => {
    const $cookiePopup = $('.js-cookie-popup');
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $jsScrollTo = $('.js-scroll-to');
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    if (document.querySelector('.js-nav')) {
        new Nav();
    }

    const $banner = $('.js-banner');
    if ($banner.length) {
        $banner.map((i, v) => banner(v));
    }

    dropdownMenu();

    const $embedMessage = $('.js-embed-message');
    if ($embedMessage.length) {
        $embedMessage.map((i, v) => embedMessage(v));
    }

});
